module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/cover-bea0ca3e016809f503ac1dd3bd7332b3.webp";